module.exports = __webpack_public_path__ + "img/[睡].a16c9eb6.svg";